<template>
  <div class="parentx">
  <vs-sidebar
      v-model="menuVisible">
    <div>
      <!-- Header -->
      <div class="header-sidebar flex items-end justify-between" slot="header">
        <!-- Menu Buttons -->
        <div>
          <!-- Close Button -->
          <template v-if="showCloseButton">
            <feather-icon
              icon="XIcon" class="m-0 cursor-pointer"
              @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
          </template>
        </div>
        <!-- /Menu Toggle Buttons -->
      </div>
      <!-- /Header -->

      <!-- Header Shadow -->
      <div class="shadow-bottom" v-show="showShadowBottom" />

      <!-- Menu Items -->
      <component
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu pt-2"
          :settings="settings"
          @ps-scroll-y="psSectionScroll"
          @scroll="psSectionScroll"
          :key="$vs.rtl">
        <template v-for="(item, index) in items">

          <template>
            <!-- Nav-Item -->
            <v-nav-menu-item
                v-if="item.children.length === 0"
                :key="`item-${index}`"
                :index="index"
                :to="item.route.path"
                :icon="item.icon"
                :slug="item.route.path">
              <span v-show="!verticalNavMenuItemsMin" class="truncate">{{ item.text }}</span>
              <vs-chip class="ml-auto" :color="item.tagColor" v-if="item.tag && (isMouseEnter || !reduce)">{{ item.tag }}</vs-chip>
            </v-nav-menu-item>

            <!-- Nav-Group -->
            <template v-else>
              <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)" />
            </template>
            <!-- /Nav-Group -->
          </template>
        </template>
      </component>
      <!-- /Menu Items -->
    </div>
  </vs-sidebar>
  </div>
</template>

<script>
import {mapState} from "vuex";
import VNavMenuItem from "../vertical-nav-menu/VerticalNavMenuItem";
import VNavMenuGroup from "../vertical-nav-menu/VerticalNavMenuGroup";

export default {
  name: "vSidebar",
  components: {VNavMenuGroup, VNavMenuItem},
  computed: {
    ...mapState("menu", ["items", 'showNavMenu', 'rolesOfUser']),
  },
  data: () => ({
    menuVisible: true,
    scrollbarTag: 'VuePerfectScrollbar',
    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    verticalNavMenuItemsMin: false,
    openGroupHover: false,
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false
  }),
  methods: {
    psSectionScroll () {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0
    },
    toggleReduce() {

    },
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false
        const func = (item) => {
          if (item.text) {
            item.children.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) {
                open = true
              } else if (item.text) {
                func(item)
              }
            })
          }
        }
        func(item)
        return open
      }
    },
  }
}
</script>

<style scoped>
.vs-collapse, .vs-sidebar--item {
  padding: 0px !important;
}
</style>
